export default function getTransferByProductToken(transfers, productToken) {
  if (!transfers || !productToken) {
    return null;
  }

  return transfers.find((transfer) => transfer.productToken === productToken);
}
